export const CART_REQUEST_PENDING = "CART_REQUEST_PENDING";
export const CART_REQUEST_SUCCESS = "CART_REQUEST_SUCCESS";
export const CART_REQUEST_FAILURE = "CART_REQUEST_FAILURE";
